import PlasticExchangeDelivery from '@/src/modules/pg-plus/redemption/forms/PlasticExchangeDelivery'
import { RecipientDeliveryContextProvider } from '@/src/common/contexts/RecipientDeliveryContext'

interface IPlasticWalletDetails {
    hasBeenCardLinked: boolean
    showBackButton: boolean
    refetchGift: Function
}

const PlasticRedemptionInWalletOrGiftDetails = ({
    hasBeenCardLinked,
    showBackButton,
    refetchGift,
}: IPlasticWalletDetails) => {
    return (
        <RecipientDeliveryContextProvider>
            <PlasticExchangeDelivery
                showBackButton={showBackButton}
                hasBeenCardLinked={hasBeenCardLinked}
                refetchGift={refetchGift}
            />
        </RecipientDeliveryContextProvider>
    )
}

export default PlasticRedemptionInWalletOrGiftDetails
